import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Icon } from '../../../../../../common/html/icon'
import { TextEllipsisStaticLine } from '../../../../../../common/textEllipsis/TextEllipsisStaticLine'

export const ColumnCellWithCollapse = ({
  ids,
  rowId,
  val,
  style,
  childIds,
  parentId,
  changeIds,
  fieldStyle,
}) => {
  const dispatch = useDispatch()
  const [isOpenCollapse, setIsOpenCollapse] = useState(true)
  const indexOfRowId = ids.indexOf(rowId)

  const onClickCollapse = () => {
    setIsOpenCollapse(!isOpenCollapse)
    if (isOpenCollapse) {
      const newIds = ids.filter((id) => !childIds.includes(id))
      dispatch(changeIds(newIds))
    }
    if (!isOpenCollapse) {
      const newIds = [
        ...ids.slice(0, indexOfRowId + 1),
        ...childIds,
        ...ids.slice(indexOfRowId + 1),
      ]
      dispatch(changeIds(newIds))
    }
  }

  return (
    <div className="dFlex alignItemsCenter" style={{ ...style }}>
      {childIds.length > 0 && !parentId && (
        <button
          style={{
            cursor: 'pointer',
            border: 'none',
            backgroundColor: 'transparent',
            paddingLeft: 0,
          }}
          className="alignItemsCenter"
          onClick={onClickCollapse}
        >
          <Icon
            className={`${
              isOpenCollapse ? 'icon-caret-bottom' : 'icon-caret-right'
            }`}
            style={{
              fontSize: 8,
              color: '#3A414B',
              padding: isOpenCollapse ? '' : '0 2px',
            }}
          />
        </button>
      )}
      <span
        style={{
          fontWeight: fieldStyle.includes('B') ? 600 : '',
          marginLeft: fieldStyle.includes('T') ? 40 : 0,
          textDecoration: `${fieldStyle.includes('U') ? 'underline' : ''} ${
            fieldStyle.includes('L') ? 'overline' : ''
          }
            `,
          fontStyle: fieldStyle.includes('I') ? 'italic' : '',
          borderBottom: fieldStyle.includes('M') ? '1px solid' : '',
          paddingRight: 1,
        }}
      >
        <TextEllipsisStaticLine
          zIndexTooltip={7}
          text={!val ? '' : fieldStyle.includes('P') ? val.toUpperCase() : val}
          isI18n={false}
          lineClamp={1}
          appendStyle={{ paddingRight: 6 }}
        />
      </span>
    </div>
  )
}
